const STORE_MATERIAL_ROWS = [
  {
    match: "Catalogue 01",
    filter: "Catalogue 01 - Titanium",
    categories: ["Titanium"],
  },
  {
    match: "Catalogue 02",
    filter: "Catalogue 02 - incl. Quantum",
    categories: ["Titanium", "Quantum High"],
  },
  {
    match: "Catalogue 03",
    filter: "Catalogue 03 - Incl Acetate",
    categories: ["Titanium", "Acetate"],
  },
  {
    match: "Catalogue 04",
    filter: "Catalogue 04 - Incl Acetate / Quantum",
    categories: ["Titanium", "Acetate", "Quantum High"],
  },
  {
    match: "Catalogue 05",
    filter: "Catalogue 05 - Titanium + NYHAVN",
    categories: ["Titanium", "Nyhavn"],
  },
  {
    match: "Catalogue 06",
    filter: "Catalogue 06 - Titanium + NYHAVN + Quantum",
    categories: ["Titanium", "Nyhavn", "Quantum High"],
  },
  {
    match: "Catalogue 07",
    filter: "Catalogue 07 - Titanium + NYHAVN + Acetate",
    categories: ["Titanium", "Acetate", "Nyhavn"],
  },
  {
    match: "Catalogue 08",
    filter: "Catalogue 08 - Titanium + NYHAVN + Acetate + Quantum",
    categories: ["Titanium", "Acetate", "Nyhavn", "Quantum High"],
  },
  {
    match: "Catalogue 09",
    filter: "Catalogue 09 - Nyhavn",
    categories: ["Nyhavn"],
  },
  {
    match: "Catalogue 10",
    filter: "Catalogue 10 - Acetate",
    categories: ["Acetate"],
  },
  {
    match: "Catalogue 11",
    filter: "Catalogue 11 - Quantum",
    categories: ["Quantum High"],
  },
  {
    match: "Catalogue 12",
    filter: "Catalogue 12 - Nyhavn+Acetate",
    categories: ["Acetate", "Nyhavn"],
  },
  {
    match: "Catalogue 13",
    filter: "Catalogue 13 - Nyhavn+Quantum",
    categories: ["Nyhavn", "Quantum High"],
  },
  {
    match: "Catalogue 14",
    filter: "Catalogue 14 - Quantum+Acetate",
    categories: ["Acetate", "Quantum High"],
  },
  {
    match: "Catalogue 15",
    filter: "Catalogue 15 - Nyhavn+Acetate+Quantum",
    categories: ["Acetate", "Nyhavn", "Quantum High"],
  },
  {
    match: "Catalogue 16",
    filter: "Catalogue 16 - Titanium + NYHAVN + Acetate + Quantum + Global Fit",
    categories: ["Titanium", "Acetate", "Nyhavn", "Quantum High", "Global FIT"],
  },
  {
    match: "Norway - Acetate",
    filter: "Norway - Acetate",
    categories: ["Acetate"],
  },
  {
    match: "Norway - Titanium + Acetate",
    filter: "Norway - Titanium + Acetate",
    categories: ["Titanium", "Acetate"],
  },
  {
    match: "Norway - Titanium",
    filter: "Norway - Titanium",
    categories: ["Titanium"],
  },
  // The API represents a blank imported material as the string "null" in its response.
  { match: "null", filter: null, categories: ["Titanium"] },
];

export const STORE_CATEGORIES = [
  "Titanium",
  "Acetate",
  "Nyhavn",
  "Quantum High",
  "Global FIT",
];

export const getStoreCategories = (storeMaterial = "") => {
  const categories = STORE_MATERIAL_ROWS.filter(({ match }) =>
    storeMaterial.includes(match),
  ).flatMap(({ categories: rowCategories }) => rowCategories);

  return [...new Set(categories)];
};

export const getStoreMaterialFilters = (category) =>
  STORE_MATERIAL_ROWS.filter(
    ({ filter, categories }) => filter && categories.includes(category),
  ).map(({ filter }) => filter);

export const isFullRangeStore = (storeMaterial) => {
  const storeCategories = getStoreCategories(storeMaterial);
  return STORE_CATEGORIES.every((category) =>
    storeCategories.includes(category),
  );
};
